import Http from "@/api/http";

export default {
  /* 账号管理 */
  // 列表
  sysUserPage: params => {
    return Http.POST("/sysUser/findByPage", params);
  },
  // 新增
  sysUserSave: params => {
    return Http.POST("/sysUser/save", params);
  },
  // 删除
  sysUserDelete: params => {
    return Http.GET("/sysUser/delete", params);
  },
  // 角色下拉
  sysGroupFindAllSel: params => {
    return Http.POST("/sysGroup/findAllSel", params);
  },

  /* 数据字典 */
  // 数据字典
  sysCodeTypeShowTree: params => {
    return Http.POST("/sysCodeType/showTree", params);
  },
  // 数据字典明细
  sysCodeTypeFindByCode: params => {
    return Http.POST("/sysCodeType/findByCode", null, null, params);
  },
  // 新增--字典明细
  sysCodeTypeSave: params => {
    return Http.POST("/sysCodeType/save", params);
  },
  // 删除-字典明细
  sysCodeTypeDelete: params => {
    return Http.GET("/sysCodeType/delete", params);
  },

  /* 角色菜单 */
  // 角色列表
  findAllRole: params => {
    return Http.POST("/sysGroup/findAll", params);
  },
  // 角色 新增/修改
  saveRole: params => {
    return Http.POST("/sysGroup/save", params);
  },
  // 删除-角色
  deleteRole: params => {
    return Http.GET("/sysGroup/delete", params);
  },
  // 菜单树
  loadAuditTree: params => {
    return Http.GET("/sysGroup/loadAuditTree", params);
  },
};
